import { ShopInstance, ProfileInstance } from '@/store'
import { catchError } from '@/utils/catchError'
// import router from '@/router'

const account = {
  state: {
    paymentMethodsEnabled: [],
    isDelinquent: false,
    accountEnabled: null,
    merchantName: '',
    accountName: '',
    activeMerchant: {},
    prodAccounts: { items: [], pagination: [] },
    loadingListProdAccount: true,
    testAccounts: { items: [], pagination: [] },
    accountSummary: {},
    hasSubscriptionEnabled: null,
    missingConfig: [],
    configs: ['Account.Inactive', 'Account.Checkout.Settings.Enabled', 'Account.Payment.Methods']
  },
  getters: {
    accountEnabled (state) {
      return state.accountEnabled
    },
    paymentMethodsEnabled (state) {
      return state.paymentMethodsEnabled
    },
    prodAccounts (state) {
      return state.prodAccounts
    },
    loadingListProdAccount (state) {
      return state.loadingListProdAccount
    },
    testAccounts (state) {
      return state.testAccounts
    },
    accountSummary (state) {
      return state.accountSummary
    },
    isDelinquent (state) {
      return state.isDelinquent
    },
    hasSubscriptionEnabled (state) {
      return state.hasSubscriptionEnabled
    },
    missingConfig (state) {
      return state.missingConfig
    },
    configs (state) {
      return state.configs
    }
  },
  mutations: {
    'SET_ACCOUNT_ENABLED' (state, value) {
      state.accountEnabled = value
    },
    'SET_ACCOUNT_AND_MERCHANT_INFORMATION' (state, res) {
      state.isDelinquent = res.merchant.is_delinquent
      state.activeMerchant = res.merchant
    },
    'RESET_PAYMENTS_ENABLED' (state) {
      state.paymentMethodsEnabled = []
    },
    'ADD_PAYMENTS_ENABLED' (state, value) {
      if (!state.paymentMethodsEnabled.includes(value)) state.paymentMethodsEnabled.push(value)
    },
    'HAS_SUBSCRIPTION_ENABLED' (state, value) {
      state.hasSubscriptionEnabled = value
    },
    'SET_PROD_ACCOUNTS' (state, accounts) {
      state.prodAccounts = accounts
    },
    'SET_LOADING_LIST_PROD_ACCOUNT' (state, payload) {
      state.loadingListProdAccount = payload
    },
    'SET_TEST_ACCOUNTS' (state, accounts) {
      state.testAccounts = accounts
    },
    'SET_ACCOUNT_SUMMARY' (state, value) {
      state.accountSummary = value
    },
    'SET_MISSING_CONFIG' (state, value) {
      state.missingConfig = value.map(item => {
        if (state.configs.includes(item.property)) return item.property
      })
    }
  },
  actions: {
    'GET_ACCOUNT_SUMMARY' (context, params) {
      context.commit('SET_GLOBAL_LOADING', true)
      return ShopInstance.account.getSummary(params.merchant_id, params.account_id)
        .then((res) => {
          context.commit('SET_ACCOUNT_ENABLED', true)
          context.commit('SET_ACCOUNT_SUMMARY', res)
          context.dispatch('SET_PAYMENTS_METHODS', res)
          context.commit('SET_GLOBAL_LOADING', false)
          context.commit('toggleGlobalLoading', false)
          Promise.resolve(res)
        })
        .catch((err) => {
          if (err.status === 428) {
            context.commit('SET_ACCOUNT_ENABLED', false)
            context.commit('SET_GLOBAL_LOADING', false)
            context.commit('toggleGlobalLoading', false)
            if (err.body) context.commit('SET_ACCOUNT_SUMMARY', err.body)
            context.dispatch('SET_MISSING_CONFIG', err.body)
            return Promise.reject(err)
          } else {
            return catchError(err, context)
          }
        })
    },
    'RESET_PAYMENTS_ENABLED' (context) {
      context.commit('RESET_PAYMENTS_ENABLED')
    },
    'SET_MISSING_CONFIG' (context, obj) {
      const canConfig = obj.filter(item => context.getters.configs.includes(item.property)).length
      if (canConfig) context.commit('SET_MISSING_CONFIG', obj)
    },
    'SET_PAYMENTS_METHODS' (context, obj) {
      if (obj.payment_methods.has_credit_card_enabled) context.commit('ADD_PAYMENTS_ENABLED', 'credit_card')
      if (obj.payment_methods.has_boleto_enabled) context.commit('ADD_PAYMENTS_ENABLED', 'boleto')
      if (obj.payment_methods.has_debit_card_enabled) context.commit('ADD_PAYMENTS_ENABLED', 'debit_card')
      if (obj.payment_methods.has_bank_transfer_enabled) context.commit('ADD_PAYMENTS_ENABLED', 'bank_transfer')
      if (obj.payment_methods.has_pix_enabled) context.commit('ADD_PAYMENTS_ENABLED', 'pix')
      if (obj.has_checkout_enabled) context.commit('ADD_PAYMENTS_ENABLED', 'checkout')
      if (obj.has_subscription_enabled) context.commit('HAS_SUBSCRIPTION_ENABLED', obj.has_subscription_enabled)
      else context.dispatch('SET_PAYMENT_TYPE', 'items')
    },
    'GET_PROD_ACCOUNTS' (context, params = {}) {
      params.query.size = 5
      params.query.page = params.query.page || 1
      return ProfileInstance.account.getAll(params.merchantId, params.query)
        .then((res) => {
          context.commit('SET_PROD_ACCOUNTS', res)
          context.commit('SET_LOADING_LIST_PROD_ACCOUNT', false)
          return Promise.resolve(res)
        })
        .catch((err) => {
          catchError(err, context)
        })
    },
    'GET_TEST_ACCOUNTS' (context, params = {}) {
      params.query.type = 'test'
      params.query.size = 5
      params.query.page = params.query.page || 1
      if (!context.state.testAccounts.items.length || params.query.page) {
        return ProfileInstance.account.getAll(params.merchantId, params.query)
          .then((res) => {
            context.commit('SET_TEST_ACCOUNTS', res)
            return Promise.resolve(res)
          })
          .catch((err) => {
            catchError(err, context)
          })
      } else {
        return Promise.resolve(context.state.testAccounts)
      }
    },
    'UPDATE_LOADING_LIST_PROD_ACCOUNT' (context, payload) {
      context.commit('SET_LOADING_LIST_PROD_ACCOUNT', payload)
    }
  }
}

export default account
